import API from '../app.api';

export const getSupplyList = async (disabled = false) => {
    const res = await API.get(`/api/v1/supply?disabled=${disabled}`);
    return res.data;
};
